import React, { useState } from 'react';
import { useNav } from '../App';
import { Box, Typography, Paper, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Checkbox, FormGroup } from '@mui/material';
import axios from 'axios';

function IdentifierSetup() {
  const navigate = useNav();
  const [hairType, setHairType] = useState('');
  const [facialHair, setFacialHair] = useState([]);
  const [hasGlasses, setHasGlasses] = useState('');

  const handleFacialHairChange = (value) => {
    if (facialHair.includes(value)) {
      setFacialHair(facialHair.filter(item => item !== value));
    } else {
      setFacialHair([...facialHair, value]);
    }
  };

  const handleSave = async () => {
    if (!hairType || !hasGlasses) {
      alert('Please answer all questions');
      return;
    }

    const facialHairValue = facialHair.length === 0 ? 'None' : 
                           facialHair.length === 2 ? 'Both' : facialHair[0];

    try {
      const token = localStorage.getItem('binko_token');
      await axios.post((process.env.REACT_APP_API_BASE || 'https://api.binko.me/api') + '/auth/update-identifiers', {
        hairType,
        facialHair: facialHairValue,
        hasGlasses: hasGlasses === 'yes'
      }, {
        headers: { Authorization: 'Bearer ' + token }
      });
      
      localStorage.setItem('identifiers_setup_done', 'true');
      navigate('/home');
    } catch (error) {
      alert('Failed to save identifiers');
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <Paper elevation={3} sx={{ p: 4, maxWidth: 500, width: '100%' }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
          First Time Setup
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Help others recognize you when you check into venues
        </Typography>

        <FormControl component="fieldset" sx={{ mb: 3, width: '100%' }}>
          <FormLabel component="legend" sx={{ fontWeight: 'bold', mb: 1 }}>Hair:</FormLabel>
          <RadioGroup value={hairType} onChange={(e) => setHairType(e.target.value)}>
            <FormControlLabel value="Long hair" control={<Radio />} label="Long hair" />
            <FormControlLabel value="Short hair" control={<Radio />} label="Short hair" />
            <FormControlLabel value="Bald/shaved" control={<Radio />} label="Bald / shaved" />
            <FormControlLabel value="Tied up" control={<Radio />} label="Tied up" />
          </RadioGroup>
        </FormControl>

        <FormControl component="fieldset" sx={{ mb: 3, width: '100%' }}>
          <FormLabel component="legend" sx={{ fontWeight: 'bold', mb: 1 }}>Facial hair (if applicable):</FormLabel>
          <FormGroup>
            <FormControlLabel 
              control={<Checkbox checked={facialHair.includes('Beard')} onChange={() => handleFacialHairChange('Beard')} />} 
              label="Beard" 
            />
            <FormControlLabel 
              control={<Checkbox checked={facialHair.includes('Mustache')} onChange={() => handleFacialHairChange('Mustache')} />} 
              label="Mustache" 
            />
          </FormGroup>
        </FormControl>

        <FormControl component="fieldset" sx={{ mb: 3, width: '100%' }}>
          <FormLabel component="legend" sx={{ fontWeight: 'bold', mb: 1 }}>Do you wear glasses?</FormLabel>
          <RadioGroup value={hasGlasses} onChange={(e) => setHasGlasses(e.target.value)}>
            <FormControlLabel value="yes" control={<Radio />} label="Usually wear glasses" />
            <FormControlLabel value="no" control={<Radio />} label="Don't wear glasses" />
          </RadioGroup>
        </FormControl>

        <Button variant="contained" fullWidth onClick={handleSave} size="large">
          Save to my profile
        </Button>
      </Paper>
    </Box>
  );
}

export default IdentifierSetup;
